module.exports = __webpack_public_path__ + "static/media/chemistry-min.d5967c7e.jpg";